// Entry point for the build script in your package.json
import "./libs/jquery";
import "@hotwired/turbo-rails"
import "./controllers"
import { initializeIframeMessaging } from "./utils/iframe_messaging"

// Initialize iframe messaging when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('[Application] DOM Content Loaded - initializing iframe messaging');
  initializeIframeMessaging();
});

// Also initialize on turbo:load in case we miss DOMContentLoaded
document.addEventListener('turbo:load', () => {
  console.log('[Application] Turbo Load - ensuring iframe messaging is initialized');
  initializeIframeMessaging();
});